import axios from 'axios';

const API_URL = '/api/app-pages';

export const appPageService = {
    getAllPages: async (token) => {
        try {
            const response = await axios.get(API_URL, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching all pages:', error);
            return [];
        }
    },

    createPage: async (pageData, token) => {
        try {
            const response = await axios.post(API_URL, pageData, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return { success: true, data: response.data };
        } catch (error) {
            console.error('Error creating page:', error);
            return { success: false, message: error.response?.data?.message || 'Error creating page' };
        }
    },

    updatePage: async (id, pageData, token) => {
        try {
            const response = await axios.put(`${API_URL}/${id}`, pageData, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return { success: true, data: response.data };
        } catch (error) {
            console.error('Error updating page:', error);
            return { success: false, message: error.response?.data?.message || 'Error updating page' };
        }
    },

    deletePage: async (id, token) => {
        try {
            const response = await axios.delete(`${API_URL}/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return { success: true, data: response.data };
        } catch (error) {
            console.error('Error deleting page:', error);
            return { success: false, message: error.response?.data?.message || 'Error deleting page' };
        }
    }
};
